import { cn } from "@/lib/utils"

import type { BrandTheme } from "../BrandLogo/BrandLogo"

export interface BrandMarkProps {
  size?: number
  theme?: BrandTheme
  className?: string
}

export function BrandMark({ size = 20, theme = "light", className }: BrandMarkProps) {
  const isDark = theme === "dark"
  const overlayFrom = isDark ? "white" : "#0C111D"
  const overlayTo = isDark ? "#0C111D" : "white"
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 36 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("block shrink-0", className)}
    >
      <path d="M11.6121 0.820068L22.1729 29.5739L10.8749 23.86L0 29.7583L11.6121 0.820068Z" fill="url(#mk0)" />
      <path d="M11.6121 0.820068L22.1729 29.5739L10.8749 23.86L0 29.7583L11.6121 0.820068Z" fill="url(#mk1)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3898 0.922175L14.1338 1.05161L24.4995 29.5538L29.4995 29.0495C33.0278 28.9303 35.7793 26.0791 35.6423 22.0244C35.5196 18.393 33.1236 15.4549 30.0901 14.9666C32.6611 13.8797 34.4308 11.2072 34.3274 8.1452C34.2007 4.39666 31.5208 1.09861 28.0001 0.921521L27.9994 0.916223L27.8967 0.917226C27.7654 0.912926 27.633 0.912962 27.4995 0.917471C27.4629 0.918708 27.4263 0.920277 27.3898 0.922175Z"
        fill="url(#mk2)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3898 0.922175L14.1338 1.05161L24.4995 29.5538L29.4995 29.0495C33.0278 28.9303 35.7793 26.0791 35.6423 22.0244C35.5196 18.393 33.1236 15.4549 30.0901 14.9666C32.6611 13.8797 34.4308 11.2072 34.3274 8.1452C34.2007 4.39666 31.5208 1.09861 28.0001 0.921521L27.9994 0.916223L27.8967 0.917226C27.7654 0.912926 27.633 0.912962 27.4995 0.917471C27.4629 0.918708 27.4263 0.920277 27.3898 0.922175Z"
        fill="url(#mk3)"
      />
      <defs>
        <linearGradient id="mk0" x1="-42.3964" y1="18.3758" x2="-17.4316" y2="-20.2939" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0C111D" /><stop offset="0.325461" stopColor="#0E224B" /><stop offset="1" stopColor="#155EEF" />
        </linearGradient>
        <linearGradient id="mk1" x1="2.07695" y1="15.4467" x2="51.6086" y2="17.2146" gradientUnits="userSpaceOnUse">
          <stop stopColor={overlayFrom} /><stop offset="1" stopColor={overlayTo} />
        </linearGradient>
        <linearGradient id="mk2" x1="-25.0016" y1="19.8772" x2="-0.800669" y2="-18.0789" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0C111D" /><stop offset="0.325461" stopColor="#0E224B" /><stop offset="1" stopColor="#155EEF" />
        </linearGradient>
        <linearGradient id="mk3" x1="16.572" y1="15.5525" x2="63.0433" y2="15.5433" gradientUnits="userSpaceOnUse">
          <stop stopColor={overlayFrom} /><stop offset="1" stopColor={overlayTo} />
        </linearGradient>
      </defs>
    </svg>
  )
}
